<template>
    <div>
        <Header>
            
        </Header>

        <div class="row py-3 mb-4 justify-content-between pageTitleDiv">
            <div class="container pl-0">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                    {{$ml.get('ACTIVITIES')}}
                    <span class="font-12 py-1 px-2 bg-new-badges border-radius-20 ml-2">{{totalCount}}</span>
                </div>
            </div>  
        </div>
        <div class="container">
            <div class="row py-3 mb-4 justify-content-between pageTitleDiv2">
                <div class="container pl-0">
                    <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                        {{$ml.get('ACTIVITIES')}}
                        <span class="font-12 py-1 px-2 bg-new-badges border-radius-20 ml-2">{{totalCount}}</span>
                    </div>
                </div>  
            </div>
            <div class="row mb-2 justify-content-between filtreAndTableSetting">
                <div class="d-flex" v-if="windowWidth>maxMobilSize">
                    <div class=" addBtn float-left" data-toggle="modal" >
                        <button v-show="showCalendar" @click=switchCalendarToList() type="button" class="btn btn-crm-secondary f-14 h-100" :class="{'btn-crm-active':!showCalendar}">
                            <i class="fa fa-list font-m "></i>
                        </button>   
                        <button v-show="!showCalendar" @click="showCalendar=true" type="button" class="btn btn-crm-secondary f-14 h-100" :class="{'btn-crm-active':showCalendar}">
                            <i class="fa fa-calendar-alt font-m"></i>
                        </button>  
                    </div>
                    <div v-show="!showCalendar" class="float-left ml-2 table-setting" v-if="$can('can_bulk_delete_activities')">
                        <button type="button" :title="$ml.get('BULK_ACTIONS')" class="btn btn-crm-secondary dropdown-toggle h40" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> 
                            <label class="p-0 m-0 btn-click">{{$ml.get('BULK_ACTIONS')}}</label>
                        </button>
                        <div class="dropdown-menu dropdown-menu-left dropMenu multiChoose p-0">
                            <ul class="new-dropdown p-0 border-0">
                                <!--<li class=""  @click="openBulkUpdateModal()"><i class="fa fa-exchange h-14"></i> {{$ml.get('BULK_UPDATE')}}</li>-->
                                <li class="text-danger" @click="deleteSelectedRows()" v-if="$can('can_bulk_delete_activities')"><i class="fa fa-trash h-14"></i> {{$ml.get('DELETE')}}</li>
                            </ul>
                        </div>
                    </div>

                    <div class="align-self-center tabletSlide ml-2" v-if="windowWidth>maxMobilSize">
                        <div class="activityFilter btn-group crmButonGroupsType" role="group" aria-label="activityGroupButton">
                            <button type="button" class="btn btn-click py-1 h40" :class="{active:activityFilter=='all'}" @click="activityFilter='all'">
                               
                                {{$ml.get('ALL')}}</button>
                            <button type="button" class="btn btn-click py-1 h40" :class="{active:activityFilter==1}" @click="activityFilter=1">
                                <i class="fa fa-phone-volume mr-1" style="color:#52BA9F"></i> 
                                 <label class="p-0 m-0 btn-click">{{$ml.get('CALL')}}</label></button>
                            <button type="button" class="btn btn-click py-1 h40" :class="{active:activityFilter==3}" @click="activityFilter=3">
                                <i class="fa fa-tasks mr-1" style="color:#49A7F8"></i>
                                <label class="p-0 m-0 btn-click">{{$ml.get('TASK')}}</label></button>
                            <button type="button" class="btn btn-click py-1 h40" :class="{active:activityFilter==4}" @click="activityFilter=4">
                                <i class="fa fa-envelope mr-1" style="color:#F6BD56"></i>
                                <label class="p-0 m-0 btn-click">{{$ml.get('E_MAIL')}}</label></button>
                            <button type="button" class="btn btn-click py-1 h40" :class="{active:activityFilter==2}" @click="activityFilter=2">
                                <i class="fas fa-calendar-check mr-1" style="color:#9666F6"></i>
                                <label class="p-0 m-0 btn-click">{{$ml.get('APPOINTMENT')}}</label></button>
                        </div>
                    </div>
                    
                </div>

                <div class="d-flex align-items-end">

                    <div class=" addBtn" data-toggle="modal" data-target="#add" @click="clearModal=true" >
                        <button type="button" @click="activaTab" class="btn bg-new-primary f-14 h-100">
                            <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('ADD_ACTIVITY')}}
                        </button>   
                    </div>

                    <filterComponent class="newFilterButton" @filter="filter=$event,getActivities('emitter')" @filterStatus="filterStatus=$event" ref="filter" :customFields="this.customFields" :users="this.users" :user="user" :status="true"  :isUsersList="true" :pageIs="pageIs" @updatedCalendar="updatedCalendar($event)"/>

                    <div v-show="!showCalendar" class="float-left ml-2 table-setting">
                        <button type="button" :title="$ml.get('SET_COLUMNS')" class="btn-crm-secondary btn btn-click p-2 dropdown-button h40 w40" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> 
                            <i class="fa fa-gear font-m"></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right dropMenu multiChoose p-0">
                            <div class="p-2 mcBgDark">
                                <span class="text-white">{{selectedTableView.name}}</span>
                            </div>
                            <ul class="new-dropdown p-0 border-0">
                                <li class="p-0" v-for="(col,index) in gridColumns" v-bind:key='index' v-show="(col['prop']!=='_id'&&col['prop']!=='x'&&col['prop']!=='notes'&&col['prop']!=='currency')">
                                    <label class="w-100 custom-checkbox">
                                        <input type="checkbox" :value="col['prop']" :disabled="tableConfigVisible.length <= 1 && tableConfigVisible.indexOf(col['prop']) != -1" v-model="tableConfigVisible"> 
                                        <span class="label-text f-14">{{col['name']}}</span>
                                    </label>
                                </li>
                            </ul>
                              <div class="dd-footer p-1">
                                <button type="button" data-toggle="modal"  data-target="#colListModal"  class="btn" style="background-color: #fff !important;color:#333333;border:1px solid #dcdddd">{{$ml.get('SAVED_VIEWS')}}</button>
                                <button type="button" @click="selectSaveMethod()" class="btn btn-primary" style="background-color:#1891eb !important"><i class="fa fa-save" ></i> {{$ml.get('SAVE')}}</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            

            <div class="row mb-3" v-if="windowWidth<maxMobilSize"><!--filter For Mobile-->
                <div class="align-self-center tabletSlide"> 
                    <div class="activityFilter" role="group" aria-label="activityGroupButton">
                        <button type="button" class="btn btn-click py-1" :class="{active:activityFilter=='all'}" @click="activityFilter='all'">{{$ml.get('ALL')}}</button>
                        <button type="button" class="btn btn-click py-1" :class="{active:activityFilter==1}" @click="activityFilter=1"> <label class="p-0 m-0 btn-click">{{$ml.get('CALL')}}</label></button>
                        <button type="button" class="btn btn-click py-1" :class="{active:activityFilter==3}" @click="activityFilter=3"> <label class="p-0 m-0 btn-click">{{$ml.get('TASK')}}</label></button>
                        <button type="button" class="btn btn-click py-1" :class="{active:activityFilter==4}" @click="activityFilter=4"> <label class="p-0 m-0 btn-click">{{$ml.get('E_MAIL')}}</label></button>
                        <button type="button" class="btn btn-click py-1" :class="{active:activityFilter==2}" @click="activityFilter=2"> <label class="p-0 m-0 btn-click">{{$ml.get('APPOINTMENT')}}</label></button>
                    </div>
                </div>
            </div>
            
            <div class="alert alert-secondary alert-dismissible fade show" v-if="totalCount == 0" role="alert">
                <strong>{{$ml.get('WARNING')}}</strong>
                {{$ml.get('NOT_FOUND_MESSAGE')}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">×</span>
                </button>
            </div>
           
            <div v-if="!showCalendar">
                <grid v-if="gridData.length>0 && windowWidth>maxMobilSize" @updateCheckedRows="updateCheckedRows($event)" @refleshData="getActivities('emitter')" @sortedData="getSortedData($event)" :tableConfigVisible="tableConfigVisible" :data="gridData" :columns="gridColumns" :cellUpdateUrl="activityUpdate" :permissions="permissions" :user="user"  :users="users" :filterGuide="guideCol" @scrolled="scrollfunctionOfGrid" :page="pageIs"></grid>
                <gridMobil v-else-if="gridData.length>0" @updateCheckedRows="updateCheckedRows($event)" @refleshData="getActivities('emitter')" @sortedData="getSortedData($event)" :tableConfigVisible="tableConfigVisible" :data="gridData" :columns="gridColumns" :cellUpdateUrl="activityUpdate" :permissions="permissions" :user="user"  :users="users" :filterGuide="guideCol" @scrolled="scrollfunctionOfGrid" :page="pageIs"></gridMobil>
            </div>
           

            <calendar style="margin-right:-15px; margin-left:-15px;" @filter="filter=$event,getActivities('emitter')"  :activityFilter="activityFilter" :permissions="permissions"  :filterDatas="filterDatas" :updateCalendar="updateCalendar" :filterGuide="guideCol" :data="gridData" :user="user" :users="users" v-if="showCalendar" @updatedCalendar="updatedCalendar($event)"></calendar>
            
            <div class="modal fade" id="add" ref="vuemodal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important">
                    <div class="modal-content crm-modal-content">
                        <newActivity :methods='type' :user="this.user" :clearModal="clearModal" :listenStateStatus="this.listenStateStatus" @refleshData="getActivities('emitter')" :users="this.users" @updatedCalendar="updatedCalendar($event)" :customFieldArray="customFields"></newActivity>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="colListModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="collist" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content mcBgGrey">
                        <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                            <h5 class="h5" id="saveColListModalTitle">{{$ml.get('SAVED_VIEWS')}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="font-40">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <ul class="list-group radio-list-group" >
                                <li class="list-group-item">
                                    <label for="" class="">
                                        <input type="radio" name="selectedview" v-model="selectedTableView" :value="defaultTableView"> {{$ml.get('DEFAULT_VIEW')}}
                                    </label>
                                </li>
                                <li class="list-group-item" v-for="(view,index) in tableViewList" v-bind:key="index">
                                    <label for="" class="">
                                        <input type="radio" name="selectedview" v-model="selectedTableView" :value="view" > {{view.name}}
                                    </label>
                                    <i class="fa fa-trash text-danger" @click="deleteTableViewF(view._id.$oid)"></i>
                                </li>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <div class="col-12 dealBtnStyle p-0">
                                <button class="btn-new save" v-if="tableViewList.length>0"   @click="setTableViewF(selectedTableView._id.$oid)">
                                    {{$ml.get('APPLY')}}
                                </button>
                                <button class="btn-new" data-dismiss="modal" aria-label="Close">{{$ml.get('CANCEL')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="selectMethodModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="savecollist" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content mcBgGrey">
                        <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                            <h5 class="h5" id="saveColListModalTitle">{{$ml.get('SAVE_VIEW')}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="font-40">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            “{{selectedTableView.name}}” {{$ml.get('WHICH_WAY_TO_SAVE')}}
                        </div>
                        <div class="modal-footer">
                            <div class="col-12 dealBtnStyle p-0">
                                <button class="btn-new save mcBgDark" data-dismiss="modal" aria-label="Close" data-toggle="modal"  data-target="#saveTableViewModal" >
                                    {{$ml.get('SAVE_AS')}}
                                </button>
                                <button class="btn-new save" @click="updateTableViewF()">
                                    {{$ml.get('OVERWRITE')}}
                                </button>
                                <button class="btn-new" data-dismiss="modal" aria-label="Close">{{$ml.get('CANCEL')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="saveTableViewModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="savecollist" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content mcBgGrey">
                        <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                            <h5 class="h5" id="saveColListModalTitle">{{$ml.get('SAVE_VIEW')}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="font-40">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <label for="" class="">{{$ml.get('NAME_VIEW')}}</label>
                            <input type="text" class="form-control" v-model="newTableView.name">
                            
                        </div>
                        <div class="modal-footer">
                            <div class="col-12 dealBtnStyle p-0">
                                <button class="btn-new save" @click="saveTableViewF()">{{$ml.get('SAVE')}}</button>
                                <button class="btn-new" data-dismiss="modal" aria-label="Close">
                                    {{$ml.get('CANCEL')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
        </div>    
    </div>    
</template>

<script>
import Vue from 'vue'
import Header from './header'
import Grid from './Grid'
import calendar from './calendar'
import GridMobil from "./gridMobil";
import axios from 'axios'
import newActivity from './newActivity.vue'
import filterComponent from './filterComponent.vue'
import Swal from 'sweetalert2'
import { mapState } from 'vuex'
import {mapActions} from 'vuex'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker)
export default {
    components: {
        Header,
        "grid":Grid,
        "gridMobil":GridMobil,
        "newActivity":newActivity,
        "filterComponent":filterComponent,
        calendar,
    },
    name:'Activities',
    data (){
        return {
            activities:[],
            customFields:[],
            tableConfigVisible:[],
            gridColumns: [
                {prop:'_id',name:"Id",default:true},
                {prop:'cuid', name: this.$ml.get('HOLDER'), type:"user", default:false},
                {prop:'done',name:this.$ml.get('ACTIVITY_STATUS'),type:"isDone",default:true},
                {prop:'type',name:this.$ml.get('TYPE'),type:"activityType",default:true},
                {prop:'subject',name:this.$ml.get('SUBJECT'),default:true},
                {prop:'contactId',name:this.$ml.get('RELATED_PERSON'),type:'relContact',isSort:false},
                {prop:'dealId',name:this.$ml.get('RELATED_OPPORTUNITY'),type:"deals",isSort:false},
                {prop:'orgId',name:this.$ml.get('RELATED_COMPANY'),type:'organizations',default:true},
                {prop:'assignor',name:this.$ml.get('ASSIGNMENT'),type:'user',default:true},
                {prop:'assignedTo',name:this.$ml.get('ASSIGNED'),type:'user',default:true},
                {prop:'dueDate',name:this.$ml.get('PLANNING_HISTORY'),type:"dateObj",default:true},
                {prop:'addDate',name:this.$ml.get('CREATION_DATE'),type:"dateObj",default:true},
                {prop:'doneDate',name:this.$ml.get('CLOSING_DATE'),type:"dateObj",default:true},
                {prop:'notes',name:this.$ml.get('NOTE')},
                {prop:'duration',name:this.$ml.get('PLANNED_TIME'),type:"duration"},
                /*{prop:'totalDeals',name:"Kapanış Tarihi"}*/
            ],
            gridData:[],
            pagingSize:30,
            pagingOffset:0,
            totalCount:0,
            bottom:false,
            activityUpdate:'updateActivity',
            guideCol:'name',// name column will be filtered by first letter
            type:'save',
            user:[],
            users:[],
            filter:"",
            activityFilter:'all',
            pageIs:"activity",
            clearModal:false,
            roleId:"",
            filterClear:false,
            permissions:[],
            sort:null,
            sortType:null,
            activitiesRaw:[],
            firstLoad:true,
            filterStatus:"false",
            checkedRows:[],
            checkAllRows:false,
            showCalendar:false,
            updateCalendar:0,
            filterDatas:{},
            selectedTableView:{
                _id:{$oid:''}
            },
            defaultTableView:{
                name:this.$ml.get('DEFAULT_VIEW'),
                _id:{$oid:'default-view'}
            },
            tableViewList:[],
            newTableView:{
            },
        }
    },
    methods:{
        activaTab(){
            this.$root.$refs.newActivities.activaTab()
        },
        switchCalendarToList(){
            this.showCalendar=false
            this.getActivities('emitter')
        },
        updateCheckedRows(val){
            console.log("checked rows val")
            console.log(val)
            if(val=='allRowsChecked'){
                this.checkAllRows=true
                this.checkedRows = []
            }else{
                this.checkAllRows=false
                this.checkedRows = val
            }
        },
        deleteSelectedRows(){
            if(this.checkedRows.length==0&&this.checkAllRows==false){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('NO_SELECTED_ROW_ON_DELETE'),
                    icon: "warning"
                })
                return false
            }

            var form = {}

             if(this.checkAllRows==true&&this.filter==''){
                form.all = true
            }else if(this.checkedRows.length>0){
                form.activityIds = this.checkedRows
            }
            
            if(this.filter!==''&&this.checkedRows.length==0){
                form.filter = this.filter
            }

            var confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM')
            if(this.$can('can_bulk_delete_activities')&&this.$can('can_delete_other_users_activities')){
                confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM')
            }else if(!this.$can('can_bulk_delete_activities')&&this.$can('can_delete_other_users_activities')){
                confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM_OTHERS')
            }else if(this.$can('can_bulk_delete_activities')&&!this.$can('can_delete_other_users_activities')){
                confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM_OWN')
            }

            Swal.fire({
                title: this.$ml.get('DELETE_RECORDS'),
                text: confirm_message,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: this.$ml.get('DELETE_RECORDS_CONFIRM_BTN_TXT'),
                cancelButtonText: this.$ml.get('CANCEL'),
                customClass:{
                    icon:'custom-delete-warning',
                    cancelButton:'custom-delete-cancel-button'
                },
                reverseButtons:true
            }).then((result)=>{
                if(result.isConfirmed){
                    this.deleteActivities(form).then((response)=>{
                        if(response.status.code=='0'){
                            this.$notify({ 
                                group: 'foo',
                                type: 'success', 
                                title: this.$ml.get('SUCCESSFUL'),
                                text: response.status.desc 
                            })
                            this.getActivities('emitter')
                        }else{
                            this.$notify({ 
                                group: 'foo',
                                type: 'error', 
                                title: this.$ml.get('ERROR'),
                                text: response.status.desc 
                            })
                        }
                    })
                }
            })
            
        },
        getSortedData(form){
            this.sort=form.sort
            this.sortType=form.sortType
            this.getActivities('emitter')
        },
        scrollfunctionOfGrid:function (scrollYEmit,clientHeightEmit,scrollHeightEmit){
            this.bottom = this.bottomVisible(scrollYEmit,clientHeightEmit,scrollHeightEmit)
        },
        bottomVisible(scrollYEmit,clientHeightEmit,scrollHeightEmit) {
            
            const scrollY = scrollYEmit
            const visible = clientHeightEmit
            const pageHeight = scrollHeightEmit
            const bottomOfPage = visible + scrollY >= pageHeight
            
            return bottomOfPage || pageHeight < visible
        },
        updateList(event){
            
            let obj={}

            let productObj =event
            let columns =this.gridColumns

                
            for(var column in columns){

                var colInProduct = productObj.hasOwnProperty(columns[column]['prop'])

                if(colInProduct){

                    let edObj={}

                    edObj['val']=productObj[columns[column]['prop']]
                    edObj['isEditMode']=false
                    edObj['type']=columns[column]['type']

                    obj[columns[column]['prop']]=edObj
                }else{
                    let edObj={}

                    edObj['val']=null
                    edObj['isEditMode']=false
                    edObj['type']=columns[column]['type']
                    obj[columns[column]['prop']]=edObj
                }
            }
            this.activities.push(obj)
            this.totalCount=this.totalCount+1
        },
        isActive(){
            axios({
                method:'POST',
                url:'/getUsers',
                baseURL: this.baseUrl,
                data: {
                    showPassiveUsers:true
                },
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        this.user=res.data.content.user
                        this.users=res.data.content.users
                    }else{
                    }
                }else{
                    this.$router.go(-1)
                }
            })
        },
        updatedCalendar(data){
            this.updateCalendar=this.updateCalendar+1
        },
        getActivities(emitter){
            
            if(this.windowWidth<this.maxMobilSize){
                this.gridColumns= [
                    {prop:'_id',name:"Id",default:true},
                    {prop:'cuid', name: this.$ml.get('HOLDER'), type:"user", default:false},
                    {prop:'done',name:this.$ml.get('ACTIVITY_STATUS'),type:"isDone",default:true},
                    {prop:'type',name:this.$ml.get('TYPE'),type:"activityType",default:true},
                    {prop:'contactId',name:this.$ml.get('RELATED_PERSON'),type:'relContact',isSort:false},
                    {prop:'dealId',name:this.$ml.get('RELATED_OPPORTUNITY'),type:"deals",isSort:false},
                    {prop:'orgId',name:this.$ml.get('RELATED_COMPANY'),type:'organizations',default:true},
                    {prop:'subject',name:this.$ml.get('SUBJECT'),type:'subject',default:true},
                    {prop:'assignor',name:this.$ml.get('ASSIGNMENT'),type:'user',default:true},
                    {prop:'assignedTo',name:this.$ml.get('ASSIGNED'),type:'user',default:true},
                    {prop:'dueDate',name:this.$ml.get('PLANNING_HISTORY'),type:"dateObj",default:true},
                    {prop:'addDate',name:this.$ml.get('CREATION_DATE'),type:"dateObj",default:true},
                    {prop:'doneDate',name:this.$ml.get('CLOSING_DATE'),type:"dateObj",default:true},
                    {prop:'notes',name:this.$ml.get('NOTE')},
                    {prop:'duration',name:this.$ml.get('PLANNED_TIME'),type:"duration"},
                ]
            }  

            let filterObj = {}
            if(emitter!==undefined){
                this.pagingOffset=0
                if(screen.height>720){
                    this.pagingSize=40
                }else{
                    this.pagingSize=30
                }
            }

            if(this.pagingSize!=="" && this.pagingSize!==null){
                filterObj["pagingSize"]=this.pagingSize
            }

            if(this.pagingOffset!=="" && this.pagingOffset!==null){
                filterObj["pagingOffset"]=this.pagingOffset
            }

            if(this.filter!=="" && this.filter!==[] && this.filter!==null){
                filterObj["filter"]=this.filter
                filterObj["pagingSize"]=this.pagingSize
            }else{
                if(this.filterStatus!="all"){
                    this.filter={
                        "searchMode":"activities",
                        "name":"default",
                        "ands":[]
                    }
                    filterObj["filter"]=this.filter
                }
            }
            

            if(this.filterStatus!="all"){
                if(this.filter.ands.length==0){
                    this.filter.ands.push({
                        fieldName: "done",
                        filterType: "activities",
                        operator: "equals",
                        value: false
                    })
                }
            }


            if(this.sort!=null){
                filterObj.sort=this.sort
            }
            if(this.sortType!=null){
                filterObj.sortType=this.sortType
            }
            this.filterDatas=filterObj
            axios({
                method:'POST',
                url:'/getActivities',
                baseURL: this.baseUrl,
                data: filterObj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    console.log(res.data.content.activities);
                    if(emitter!==undefined){
                        this.activities=[]
                    }
                    this.totalCount = res.data.content.pageInfo['totalCount']
                    if(res.data.content.customFields){
                        for (var item in res.data.content.customFields){
                            let obj={}

                            obj['prop']=res.data.content.customFields[item]['_id']['$oid']
                            obj['name']=res.data.content.customFields[item]['name']
                            obj['type']=res.data.content.customFields[item]['field_type']
                            if(res.data.content.customFields[item]['field_type']==4){
                                obj['users']=this.users
                            }else if(res.data.content.customFields[item]['field_type']==7||res.data.content.customFields[item]['field_type']==6){
                                obj['options']=res.data.content.customFields[item]['options']
                            }
                            

                            var existingColCount = this.gridColumns.filter(function(i){
                                if(i.name === res.data.content.customFields[item]['name']) return i.name
                            })

                            if(existingColCount.length<1){
                                this.gridColumns.push(obj)
                            }
                        }
                    }
                    
                    if(this.firstLoad){
                        for(var col in this.gridColumns){
                            if(this.gridColumns[col]['default']){
                                this.tableConfigVisible.push(this.gridColumns[col]['prop'])
                            }
                        }
                    }
                    this.firstLoad=false

                    if(res.data.content.activities){
                        this.activitiesRaw=res.data.content.activities
                        let columns =this.gridColumns

                        for (var activityObjIter in res.data.content.activities){
                            let obj={}

                            let activityObj =res.data.content.activities[activityObjIter]
 
                              
                            for(var column in columns){

                                var colInActivity = activityObj.hasOwnProperty(columns[column]['prop'])

                                if(colInActivity){

                                    let edObj={}
                        
                                    edObj['val']=activityObj[columns[column]['prop']]
                                    edObj['isEditMode']=false
                                    edObj['type']=columns[column]['type']

                                    if(columns[column]['type']=='user'){
                                        edObj['users']=this.users
                                        columns[column]['users']=this.users
                                    }

                                    if(columns[column]['type']=='duration'){

                                    }

                                    if(columns[column]['type']=='dateObj'&&activityObj[columns[column]['prop']]==null){
                                        let date = {}
                                        date['$date']=''
                                        edObj['val']=date
                                    }

                                    obj[columns[column]['prop']]=edObj
                                }else{
                                    let edObj={}

                                    edObj['val']=null
                                    edObj['isEditMode']=false
                                    edObj['type']=columns[column]['type']
                                    if(columns[column]['type']=='price'){
                                        let pricesList = []
                                        let priceObj = {}
                                        priceObj['currency']=null
                                        priceObj['price']=null
                                        pricesList.push(priceObj)
                                        edObj['val']=pricesList
                                    }else if(columns[column]['type']==4){
                                        let oid = {} 
                                        oid['$oid']=''
                                        edObj['val']={}
                                        edObj['val']['_id']=oid
                                    }else if(columns[column]['type']=='dateObj'){
                                        let date = {}
                                        date['$date']=''
                                        edObj['val']=date
                                    }else if(columns[column]['type']==5){
                                        let priceObj = {}
                                        priceObj['currency']=''
                                        priceObj['value']=''
                                        edObj['val']=priceObj
                                    }else if(columns[column]['type']==6){
                                        let selected = ""
                                        edObj['val']=selected
                                    }else if(columns[column]['type']=='isDone'){
                                        edObj['val']=false
                                    }else if(columns[column]['type']=='user'){
                                        edObj['users']=this.users
                                    }else if(columns[column]['type']==7){
                                        let optionsList = []
                                        edObj['val']=optionsList
                                    }

                                    
                                    obj[columns[column]['prop']]=edObj
                                }
                            }
                            obj['customerFiles']={val:activityObj['customerFileIds']}
                            this.activities.push(obj)
                        }
                        this.gridData = this.activities
                        
                    }
			            this.customFields=res.data.content.customFields
                        this.permissions=res.data.permissions
                         
                }
                else if(res.data.status.code==2054) {         
        this.$router.push({ path: 'settings', query: { paymentStatus: 'userManagement' } })
      } 
                else{
                    if(res.data.status.details){
                        this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.details
                        })
                    }else if(res.data.status.desc){
                        this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                        })
                    }else{
                        this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: this.$ml.get('UNKNOWN_ERROR')
                        })
                    }
                     
                }
            })
        },
        modalHidden(){
            if(this.editLineStatu){
                this.getActivities("emitter")
            }
            let statu=false
            this.$store.dispatch('editLineStatu', statu)
            this.clearModal=true
            
        },
        ...mapActions([
            'updateLoading',
            'deleteActivities',
            'getTableView',
            'addTableView',
            'updateTableView',
            'deleteTableView',
            
        ]),
        selectSaveMethod(){
            if(this.selectedTableView._id.$oid=='default-view'&&this.tableViewList.length==0){
                $('#saveTableViewModal').modal('show')
            }else{
                $('#selectMethodModal').modal('show')
            }
        },
        getTableViewF(){
            var form = {}
            form.tableName = 'crm_activities'
            this.getTableView(form).then((res)=>{
                return res
            }).then((res)=>{
                console.log("res.status.code")
                console.log(res)
                if(res.status.code=='0'){
                    this.tableViewList = res.content.tableViews

                    if(this.tableViewList.length>0){
                        
                        var getSelectedCustomView = this.tableViewList.filter(view => view.isDefault ==true)[0]
                        
                        if(getSelectedCustomView==undefined){
                            this.setDefaultTableViewF()
                        }else{
                            this.selectedTableView = getSelectedCustomView
                            this.tableConfigVisible = this.selectedTableView.fields
                            console.log('custom-view set')
                        }
                        
                    }else{
                        this.setDefaultTableViewF()
                    }
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.status.desc 
                    })
                }
            })
        },
        setDefaultTableViewF(){
            var defaultViews = this.gridColumns.filter(col => col.default == true).map(item => item.prop)
            this.tableConfigVisible = defaultViews
            this.defaultTableView.fields = this.tableConfigVisible
            this.defaultTableView.name = this.$ml.get('DEFAULT_VIEW')
            this.selectedTableView = this.defaultTableView
            console.log('custom-view set')   
        },
        setTableViewF(tableViewId){
            if(tableViewId == 'default-view'){
                //this.setDefaultTableViewF()
                var form = {}
                form.tableViewId = this.tableViewList.filter(view => view.isDefault ==true)[0]._id.$oid
                form.isDefault = false
                this.updateTableView(form).then((res)=>{
                    return res
                }).then((res)=>{
                    if(res.status.code=="0"){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('SUCCESSFUL'),
                            text: res.status.desc 
                        })
                        $('#colListModal').modal('hide')
                        this.getTableViewF()
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: res.status.desc 
                        })
                    }
                })
            }else{
                var theView = this.tableViewList.filter((item)=>{
                    return item._id.$oid == tableViewId
                })
                var form = {}
                this.tableConfigVisible = theView[0].fields
                this.selectedTableView = theView[0]
                
                form.tableViewId = this.selectedTableView._id.$oid
                form.isDefault = true
                this.updateTableView(form).then((res)=>{
                    return res
                }).then((res)=>{
                    if(res.status.code=="0"){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('SUCCESSFUL'),
                            text: res.status.desc 
                        })
                        $('#colListModal').modal('hide')
                        this.getTableViewF()
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: res.status.desc 
                        })
                    }
                })
            } 
        },
        saveTableViewF(){
            var actualName = this.newTableView.name
            var duplicatedNames = this.tableViewList.filter((item)=>{
                return item.name == actualName
            })  
            if(duplicatedNames.length>0){
                $('#saveTableViewModal').modal('hide')
                $('#confirmOverwriteModal').modal('show')
            }else if(actualName=='Standart görünüm'||actualName=='Default view'){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('ENTER_ANOTHER_NAME'),
                    icon: 'warning'
                })
            }else{
                this.addTableViewF()
            }
            
        },
        addTableViewF(){
            var form = {}
            form.fields = this.tableConfigVisible
            form.tableName = 'crm_activities'
            form.name = this.newTableView.name
            form.isDefault = false
            this.addTableView(form).then((res)=>{
                return res
            }).then((res)=>{
                console.log(res);
                if(res.status.code=="0"){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.status.desc 
                    })
                    $('#saveTableViewModal').modal('hide')
                    $('#confirmOverwriteModal').modal('hide')
                    this.getTableViewF()
                }
            })
        },
        updateTableViewF(){
            var form = {}
            form.fields = this.tableConfigVisible
            form.tableViewId = this.selectedTableView._id.$oid
            form.name = this.selectedTableView.name
            form.isDefault = this.selectedTableView.isDefault
            this.updateTableView(form).then((res)=>{
                return res
            }).then((res)=>{
                if(res.status.code=="0"){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.status.desc 
                    })
                    $('#saveTableViewModal').modal('hide')
                    $('#selectMethodModal').modal('hide')
                    $('#confirmOverwriteModal').modal('hide')
                    this.getTableViewF()
                }
            })
        },
        deleteTableViewF(tableViewId){
            Swal.fire({
                title: this.$ml.get('DELETE_RECORD'),
                text: this.$ml.get('DELETE_TABLE_VIEW_CONFIRM'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: this.$ml.get('DELETE_RECORD_CONFIRM_BTN_TXT'),
                cancelButtonText: this.$ml.get('CANCEL'),
                customClass:{
                    icon:'custom-delete-warning',
                    cancelButton:'custom-delete-cancel-button'
                },
                reverseButtons:true
            }).then((result)=>{
                if(result.isConfirmed){
                    var form = {}
                    form.tableViewId = tableViewId
                    this.deleteTableView(form).then((res)=>{
                        return res
                    }).then((res)=>{
                        if(res.status.code=="0"){
                            this.$notify({ 
                                group: 'foo',
                                type: 'success', 
                                title: this.$ml.get('SUCCESSFUL'),
                                text: res.status.desc 
                            })
                            this.getTableViewF()
                        }
                    })
                }
            })
        },
    },
    computed:{
        ...mapState([
            'baseUrl',
            'editLine',
            'editLineStatu',
            'windowWidth',
            'maxMobilSize',
            'maxTabletSize'
        ]),
        listenState() { return this.$store.state.editLine },
        listenStateStatus() { return this.$store.state.editLineStatu }
    },
    created(){
        this.getActivities("emitter")
        if(localStorage.roleId!==undefined){
            this.roleId=localStorage.roleId
        }else{
            this.roleId="2"
        }
          this.$root.$refs.Activities = this
    },
    mounted(){
        this.getTableViewF()
        this.isActive()
        $(this.$refs.vuemodal).on("hidden.bs.modal", this.modalHidden)
        if(screen.height>720){
            this.pagingSize=40
        }else{
            this.pagingSize=30
        }},
    watch:{
        permissions:function(){
            if(this.permissions===undefined){
                this.permissions=[]
            }
        },
        bottom(bottom) {
            if (bottom) {
                this.pagingOffset+=this.pagingSize
                this.getActivities()
            }
        },
        activityFilter:function(){
            this.$refs.filter.childFilter(this.activityFilter,"type");
        }
    }
}
</script>

<style scoped>
    .modal .animation-content .modal-card {
    overflow: visible !important;
    }
    .modal-card-body {
    overflow: visible !important;
    }
    .filter-grup button:first-child {
        border-top-left-radius: 14px;
        border-bottom-left-radius: 14px;
    }

    .filter-grup button:last-child {
        border-top-right-radius: 14px;
        border-bottom-right-radius: 14px;
    }
    .filter-grup .last{
        border-top-right-radius: 14px!important;
        border-bottom-right-radius: 14px!important;
    }
    .filter-grup button {
        height: 36px;
        font-size: 14px!important;
        font-family: "font-family-bold";
        background-color: white;
        border: 1px solid #3767a0;
    }
    .filter-grup .active{
        background-color: #3767a0;
        color:white
    }
    .btn-crm-active{
       background-color:rgba(55, 103, 160, 0.1);;
       color: rgba(51, 51, 51, 0.8);   
    }
    .pageTitleDiv{
        background-color: #fff;
        /* position: sticky; */
        top: 60px;
        z-index: 99;
    }    
    .pageTitleDiv2{
        display: none;
    }
    .filtreAndTableSetting{
    background-color: transparent;
    box-sizing: border-box;
    padding: 0px 0px 8px 0px;
    border-bottom: 0;
}

    @media (max-width: 992px){
        .pageTitleDiv{
        display: initial;
    }
        .pageTitleDiv2{
       display: inline-block;
           margin-bottom: 0 !important;
    }
    }
    @media(max-width: 768px){
        .btn-crm-secondary {
            background-color: #f2f2f2 !important;
        }
    }
</style>
